import { jsx as t, jsxs as i } from "react/jsx-runtime";
import { Icon as a } from "@tameeni/icons";
import { Button as l } from "@tameeni/ui";
import { HomeSection as m } from "../home-section/home-section.js";
function f({
  children: n,
  ...e
}) {
  return /* @__PURE__ */ t(m, { ...e, className: "px-0", children: /* @__PURE__ */ i("div", { className: "w-full max-w-[760px] mx-auto flex flex-col justify-center gap-2", children: [
    n,
    e.link && /* @__PURE__ */ t(l, { variant: "text", size: "md", children: /* @__PURE__ */ i(
      "a",
      {
        className: "font-medium text-base flex gap-2 items-center",
        href: e.link,
        children: [
          /* @__PURE__ */ t("span", { children: e.linkLabel }),
          /* @__PURE__ */ t(a, { name: "Chevron", className: "size-5 rtl:rotate-180" })
        ]
      }
    ) })
  ] }) });
}
export {
  f as FaqSection
};
//# sourceMappingURL=index.js.map
